import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRuler = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.875 7H3.125C1.953 7 1 7.897 1 9V15C1 16.103 1.953 17 3.125 17H20.875C22.047 17 23 16.103 23 15V9C23 7.897 22.047 7 20.875 7ZM20.875 15H3.125C3.068 15 3.029 14.984 3.012 14.984C3.005 14.984 3.001 14.986 3 14.992L2.988 9.046C2.995 9.036 3.04 9 3.125 9H5V12H7V9H9V13H11V9H13V12H15V9H17V13H19V9H20.875C20.954 9.001 20.997 9.028 21 9.008L21.012 14.954C21.005 14.964 20.96 15 20.875 15Z",
		fill: "currentColor"
	})
});
export default SvgRuler;
